import React, { useState, useEffect } from "react";
import axios from "axios";
import { APIURL } from "../../../Global";
import "./machines.css";
import MachineList from "./MachineList";
import AddMachine from "./AddMachine";

function MachineHome() {
    const [machines, setMachines] = useState([]);
    const [loading, setLoading] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [selectedMachine, setSelectedMachine] = useState(null);

    const fetchMachines = async () => {
        setLoading(true);
        const tokenString = sessionStorage.getItem("usertoken");
        const token = tokenString ? tokenString.replace(/["]+/g, "") : "";

        try {
            const response = await axios.get(`${APIURL}/api/v1/staff/machine-view/`, {
                headers: { Authorization: `Token ${token}` }
            });

            if (response.data.status === "success") {
                setMachines(response.data.machines || []);
            }
        } catch (error) {
            console.error("Error fetching machines:", error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchMachines();
    }, []);

    const handleAddClick = () => {
        setSelectedMachine(null);
        setShowModal(true);
    };

    const handleEditClick = (machine) => {
        setSelectedMachine(machine);
        setShowModal(true);
    };

    return (
        <div className="machine-container">
            <div className="machine-header">
                <h3 className="machine-title"></h3>
                <button className="add-machine-btn" onClick={handleAddClick}>
                    <i className="fas fa-plus"></i> Add Machine
                </button>
            </div>

            <MachineList 
                machines={machines} 
                loading={loading}
                onEdit={handleEditClick}
                onDelete={fetchMachines}
            />

            <AddMachine 
                show={showModal} 
                onHide={() => setShowModal(false)}
                machine={selectedMachine}
                onSuccess={fetchMachines}
            />
        </div>
    );
}

export default MachineHome;
